<template>
    <div class="container-fluid my-4" v-if="prodnuevos.length > 0">

        <div class="header-banner-bar d-flex justify-content-between align-items-center mb-3">

            <div class="w-100 text-center">
                <h4 class="mb-0 text-dark"><b>Productos más comprados</b></h4>
            </div>

            <div class="d-flex align-items-center flex-shrink-0">
                <button class="btn btn-outline-secondary me-2" @click="prevItem" :disabled="currentIndex === 0">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <button class="btn btn-outline-secondary" @click="nextItem"
                    :disabled="currentIndex + visibleCount >= prodnuevos.length">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>

        </div>

        <div class="row g-3">
            <div class="col-6 col-md-4 col-lg-3" v-for="(producto, index) in productosVisibles" :key="index">
                <cardprods :item="producto"></cardprods>
            </div>
        </div>
    </div>
</template>


<script>
import cardprods from '../components/navegation/ComponentsRecomend/PresentacionProductos/cardsprods2.vue'

export default {
    components: {
        cardprods
    },
    data() {
        return {
            prodnuevos: [],
            currentIndex: 0,
            visibleCount: 4
        };
    },
    computed: {
        productosVisibles() {
            return this.prodnuevos.slice(this.currentIndex, this.currentIndex + this.visibleCount);
        }
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.get('/api/controllerpeticiones/prodsbannerbestbuy');
                this.prodnuevos = response.data.filtrado.length > 0 ? response.data.filtrado[0].Prods : [];
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        nextItem() {
            if (this.currentIndex + this.visibleCount < this.prodnuevos.length) {
                this.currentIndex++;
            }
        },
        prevItem() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            }
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>